import moment, { Moment, MomentInput } from 'moment';

/** Strict UTC parser shared by stored-date helpers and validators. */
export const parseUtcStrict = (value: MomentInput): Moment => moment.utc(value, true);

/** Strict UTC parser for picker-like calendar inputs in MM/DD/YYYY. */
export const parsePickerDateUtcStrict = (value: string): Moment => moment.utc(value, 'MM/DD/YYYY', true);

/** Calendar date (YYYY-MM-DD) from stored values parsed in strict UTC. */
export const getStoredCalendarDate = (date: string): string | null => {
  const parsedUtc = parseUtcStrict(date);
  return parsedUtc.isValid() ? parsedUtc.format('YYYY-MM-DD') : null;
};
